import React from "react";

export default class PageFooter extends React.Component {
    render() {
        return (
            <div className="footer">
                <img className="mob-logo" src="https://ss7.vzw.com/is/image/VerizonWireless/vzw-logo-156-130-c?$pngalpha$&wid=156&hei=35"/>
                &copy; 2017 Verizon Wireless
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/js/components/PageFooter.js